import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ filters, onFilterChange, onReset }) => {
  const threatLevelOptions = [
    { value: 'all', label: 'All Threat Levels' },
    { value: 'Critical', label: 'Critical' },
    { value: 'Endangered', label: 'Endangered' },
    { value: 'Vulnerable', label: 'Vulnerable' },
    { value: 'Stable', label: 'Stable' }
  ];

  const trendOptions = [
    { value: 'all', label: 'All Trends' },
    { value: 'increasing', label: 'Increasing' },
    { value: 'stable', label: 'Stable' },
    { value: 'decreasing', label: 'Decreasing' }
  ];

  const habitatOptions = [
    { value: 'all', label: 'All Habitats' },
    { value: 'Forest', label: 'Forest' },
    { value: 'Coastal', label: 'Coastal' },
    { value: 'Marine', label: 'Marine' },
    { value: 'Grassland', label: 'Grassland' }
  ];

  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Filter Species</h3>
        <Button variant="ghost" size="sm" onClick={onReset} iconName="RotateCcw">
          Reset
        </Button>
      </div>
      <div className="space-y-4">
        <Input
          type="search"
          placeholder="Search by species name..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
        />

        <Select
          label="Threat Level"
          options={threatLevelOptions}
          value={filters?.threatLevel}
          onChange={(value) => onFilterChange('threatLevel', value)}
        />

        <Select
          label="Population Trend"
          options={trendOptions}
          value={filters?.trend}
          onChange={(value) => onFilterChange('trend', value)}
        />

        <Select
          label="Habitat Type"
          options={habitatOptions}
          value={filters?.habitat}
          onChange={(value) => onFilterChange('habitat', value)}
        />

        <div className="pt-4 border-t border-border">
          <Button variant="default" fullWidth iconName="Filter">
            Apply Filters
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;